module.exports = __webpack_public_path__ + "static/media/loading.d930721d.gif";